<template>
	<div v-show="bodyshow">
		<div class="clearfix headerTag"  v-show="callBack">
			<a class="fl back" href="javascript:history.go(-1)" >返回</a>
			<span>对比车型</span>
			<button v-show="!listType && carList.length > 0" @click="edit()" class="fr editBtn">编辑</button>
			<button v-show="listType && carList.length > 0" @click="compelete()" class="fr editBtn">完成</button>
		</div>
		<section v-if="carList.length > 0">
			<div class="addCarWarp">
				<button @click="addCarStyle()" class="addCar">
					<span class="plus">+</span>&nbsp;添加车型
				</button>
			</div>
			<ul class="carList">
				<li v-for="(item,index) in carList" @click="checkedIt(index)">
					<em :class="['carListCheck',{'active':item.active}]"></em>{{item.carName}}&nbsp;{{item.carStyleName}}&nbsp;{{item.year}}
				</li>
			</ul>
			<button :disabled="checkedCarNum < 2" @click="beginComparison" v-show="!listType" :class="['begin',{'beginDisabled':checkedCarNum < 2}]">开始对比</button>
			<div v-show="listType" class="clearfix editBtnWarp">
				<button @click="clearList()" class="fl clearBtn">清空</button>
				<button @click="deleteItem()" class="fl deleteBtn">删除</button>
			</div>
		</section>
		<section class="noCarImgWarp" v-else>
			<em class="noCarImg"></em>
			<p class="noCarTxt">亲，还没有车款进行对比！</p>
			<button @click="addCarStyle()" class="firstAdd">添加车型</button>
		</section>
		<choicecar v-on:checkModelId = "addModel" ref="choicecar"></choicecar>
	</div>
</template>
<style scoped lang="less">
	
</style>
<script>
	import { Toast } from 'mint-ui';
	import { MessageBox } from 'mint-ui';
	import choicecar from "@/components/comparison/choicecar.vue"
	export default {
		name: 'comparison',
		data:function() {
			return {
				callBack:true,
				bodyshow:false,
				carList:[
					// {
					// 	id:1,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:2,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:3,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:4,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:5,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:1,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:2,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:3,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:4,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// },
					// {
					// 	id:5,
					// 	carName:"长安CS35",
					// 	carStyleName:"1.5L 手动  豪华运动型",
					// 	year:"2016款",
					// 	active:false
					// }
				],
				listType:false,/*false --- 编辑完成状态   true --- 编辑状态*/
				checkedCarNum:0,
				comparisonModelIdStr:"",
				comparisonModelIdArr:[]
			}
		},
		components:{
			choicecar
		},
		mounted: function() {
			var self = this;
			getCommonJsIns.initCSSNEW();
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/comparison/comparison.css?v=12r22e3"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			//this.checkedIt();
			//alert(this.checkedCarNum);	
			/***统计添加**/
			! function(e, t, n, g, i) {
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
		},
		methods: {
			webReady: function() {	
				var self = this;
				this.initComparisonModelId();
				this.initComparisonList();
				document.title='对比车型';
				if(self.$route.query.hiddenNav==1){
		  			self.callBack=false;
		  		}
			},
			initComparisonModelId:function(){
				this.comparisonModelIdStr = webCommonUtil.commonFun.localStore("comparisonModelId")?webCommonUtil.commonFun.localStore("comparisonModelId"):"";
				this.comparisonModelIdArr = this.comparisonModelIdStr.split(",");

			},
			initComparisonList:function(){
				var self = this;
				self.bodyshow = false;
				self.carList = [];
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonListbycarids,
					type:"get",
					data:{
						carIds:self.comparisonModelIdStr 
					},
					success:function(data){
						if(data.responseHeader.status == 200){
							//console.log(data);
							for(var i in data.response.result){
								self.carList.unshift(data.response.result[i]);
							}
							for(var j = 0 ; j < self.carList.length ; j++){
								if(j < 10){
									self.carList[j].active = true;
								}
							}
						}
						self.bodyshow = true;
						self.checkedCarNum = data.response.result.length;
					},
					error:function(){
						self.bodyshow = true;
					}
				})
			},
			//选择对比项
			checkedIt: function(index){
				if(this.checkedCarNum >= 10 && !this.carList[index].active){
					Toast({
					  message: '最多添加10个对比车型',
					  position: 'middle',
					  duration: 2000
					});
				}else{
					this.carList[index].active = !this.carList[index].active;
				}
				this.checkedCarNum = 0;
				for(var i in this.carList){
					if(this.carList[i].active){
						this.checkedCarNum += 1;
					}
				}
				
			},
			//重置列表选中状态
			resetList: function(){
				this.carList.forEach(function(item,index){
					item.active = false;
				})
				this.checkedCarNum = 0;
			},
			//开启编辑状态
			edit: function(){
				this.listType = !this.listType;
				this.resetList();
			},
			//完成编辑状态
			compelete: function(){
				this.listType = !this.listType;
				this.resetList();
			},
			//全部清空
			clearList:function(){
				var self = this;
				MessageBox.confirm("确认删除全部对比车款？").then(function(action){
				  window.localStorage.removeItem("comparisonModelId");
				  self.initComparisonModelId();
				  self.initComparisonList();
				  self.listType = false;
				  self.resetList();
				});
			},
			//单个删除
			deleteItem:function(){
				//var temp = [];
				//存储要删掉的modelid
				var indexList = [];
				//TODO 调用删除接口
				this.carList.forEach(function(item,index){
					if(item.active == false){
						indexList.push(item.id);
					}
				});
				//初始化
				// this.initComparisonModelId();
				// for(var i in this.comparisonModelIdArr){
				// 	for(var j in indexList){
				// 		console.log(this.comparisonModelIdArr[i]);
				// 		console.log(indexList[j]);
				// 		if(this.comparisonModelIdArr[i] == indexList[j]){
				// 			temp.push(this.comparisonModelIdArr[i])
				// 		}
				// 	}	
				// }
				this.comparisonModelIdArr = indexList;
				this.comparisonModelIdStr = this.comparisonModelIdArr.join(",");
				if(this.comparisonModelIdArr.length > 0){
					webCommonUtil.commonFun.localStore("comparisonModelId",this.comparisonModelIdStr);
				}else{
					window.localStorage.removeItem("comparisonModelId");
				}
				this.initComparisonList();
			},
			//添加车型
			addCarStyle:function(){
				//this.$refs.choicecar.showCarList();
				if(this.carList.length >= 30){
					Toast({
					  message: '最多添加30个对比车型',
					  position: 'middle',
					  duration: 5000
					});
				}else{
					this.$refs.choicecar.initSide();
				}
				
			},
			//添加车款成功
			addModel:function(item){
				//不得重复添加车型
				for(var i in this.carList){
					if(this.carList[i].id == item.id){
						Toast({
						  message: '请不要重复添加车款',
						  position: 'middle',
						  duration: 5000
						});
						return;
					}
				};
				if(this.comparisonModelIdStr != ""){
					this.comparisonModelIdStr = this.comparisonModelIdStr + "," + item.id;
				}else{
					this.comparisonModelIdStr = item.id+"";
				}
				//console.log(this.comparisonModelIdStr);
				
				webCommonUtil.commonFun.localStore("comparisonModelId",this.comparisonModelIdStr);

				this.initComparisonList();

				// var temp = {
				// 	id:item.id,
				// 	carName:item.name,
				// 	carStyleName:"",
				// 	year:item.year+"款",
				// 	active:false
				// };
				// this.carList.push(temp);
			},
			beginComparison:function(){
				var str = "";
				for(var i in this.carList){
					if(this.carList[i].active == true){
							str += this.carList[i].id+",";
					}
				}
				str = str.substr(0,str.length-1);
				window.location.href = "/mapply/comparisonparameter?carIds="+str;
				//this.$router.push({"path":"/mapply/comparisonparameter"})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/comparison/comparison.vue